<div mat-dialog-title>
  <h1 class="title-dialog">{{ data.title }}</h1>
  <button mat-icon-button mat-dialog-close [disableRipple]="true">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="dialog-content">
  <div class="container-inner-template" *ngIf="data.templateVariable">
    <ng-container [ngTemplateOutlet]="data.templateVariable" [ngTemplateOutletContext]="{ data }"> </ng-container>
  </div>
</div>
<div mat-dialog-actions *ngIf="data.btnTemplateVariable" align="end">
  <ng-container [ngTemplateOutlet]="data.btnTemplateVariable" [ngTemplateOutletContext]="{ data }"> </ng-container>
</div>
